import { URL } from '../../../config.js';
import { axios } from '../../../handlers/RequestHandler';
import { tableUpdate }from './../tableActions';
//import store from '../store';
import Notification from '../../../handlers/Notification';
import { FloatPrecision, localizedErrorHandler } from './../UtilsOperation';
import { DEFAULT_TIME_ZONE,COMPANY_ACCESS, MIN_LIST } from '../../../constants/general';


function saveBranchSettings(companyId, branchId, data) {
	return axios.patch(URL + companyId + '/branches/' + branchId + '/settings', data)
}
function saveBranchData(companyId, data) {
	return axios.patch(URL + companyId + '/branches/' + data.id, data)
}
const clearAdmindAccessList = () => {
    return (dispatch, getState) => {
        dispatch({
            type: 'FETCH_ADMINS_ACCESS',
            admindAccessList:[]
        })
    }
}

const updateBranchSettings = (activeFormTab) => {
    return (dispatch,getState) => {
		let { company, json_lang, branch, editable_company_settings } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
		let formOnlyInputs;

		if (activeFormTab === "1"){
			formOnlyInputs = {
				name: branch.name,
				phone: branch.phone,
				eta: branch.eta,
				description: branch.description,
				uid: editable_company_settings.uid
			};
		}
		else if (activeFormTab === "2") {
			formOnlyInputs = {
				address: branch.address,
				latitude_e6: branch.latitude_e6,
				longitude_e6: branch.longitude_e6
			};
		}
		else if (activeFormTab === "3") {
			formOnlyInputs = {
				service_fee_name: editable_company_settings.service_fee_name,
				human_service_fee_prc: editable_company_settings.human_service_fee_prc,
				human_branch_fee_prc: editable_company_settings.human_branch_fee_prc,
				human_order_tax_prc: editable_company_settings.human_order_tax_prc,
				human_delivery_discount_prc: editable_company_settings.human_delivery_discount_prc,
				order_expiration_minutes: editable_company_settings.order_expiration_minutes,
			};
		}

		// saveBranchSettings modifica algunos valores visibles, entonces para que esos cambios existan en
		// saveBranchData, debo hacerlos uno luego del otro... por eso esta sintaxys
		return saveBranchSettings(company.id, branch.id, formOnlyInputs)
			.then( async (res) => {
				// necesito actualizar en localstorage los settings q son visibles,
				// a partir de los cambios en los settings q no son visibles
				const newBranch = {
					...branch,
					service_fee_name: res.data.service_fee_name,
					human_delivery_discount_prc: res.data.human_delivery_discount_prc,
					human_delivery_fee_e2: res.data.human_delivery_fee_e2,
					human_service_fee_prc: res.data.human_service_fee_prc,
					order_expiration_minutes: res.data.order_expiration_minutes,

					//human_delivery_providers_prc: res.human_delivery_providers_prc,
					//human_service_fee_flat_e2: res.human_service_fee_flat_e2,
				}
				// como requiero ambos valores, retorno un array
				return [res.data, await saveBranchData(company.id, newBranch)];
			})
			.then( values => {
				dispatch({type: "WAIT_FOR_RESPONSE"})
				localStorage.setItem("activeBranch", JSON.stringify(values[1].data ))
				Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });

				dispatch({
					type: 'COMPANY_SETTINGS_UPDATE',
					editable_company_settings: {
						...editable_company_settings,
						...formOnlyInputs
					}
				})
			})
			.catch((err) => {
				if(err.message && err.message !== 'generic')
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
				else
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
			});
    }
}

const updateBranchInfo = () => {
	return (dispatch,getState) => {
		let { company, json_lang,branch,initialBranch } = getState();
		if(!branch.domain || branch.domain=== ""){
			Notification.show({type: "error", title:`Error`, msg:`Es requerido el dominio del comercio`});
			return
		}
		if(!branch.city_id){
			Notification.show({type: "error", title:`La ciudad es requerida`, msg:`Por favor seleccione una ciudad`});
			return
		}
		if(branch.domain.length <= 2){
			Notification.show({type: "error", title:`Error`, msg:`El dominio del comercio requiere un minimo de 3 carácteres`});
			return
		}
		let data={
			domain:encodeURIComponent(branch.domain)
		}

		if(initialBranch.name !== branch.name){
            data.name = branch.name
        }

        if(initialBranch.description !== branch.description){
            data.description = branch.description
        }

        if(initialBranch.phone !== branch.phone){
            data.phone = branch.phone
        }

        if(initialBranch.eta !== branch.eta){
            data.eta = branch.eta
        }

        if(initialBranch.in_order !== branch.in_order){
            data.in_order = branch.in_order
        }

        if(initialBranch.time_zone_offset !== branch.time_zone_offset){
            data.time_zone_offset = branch.time_zone_offset
        }

		if(initialBranch.options !== branch.options){
            data.options = branch.options
        }

		if(initialBranch.city_id !== branch.city_id){
            data.city_id = branch.city_id || null
        }

		if(initialBranch.has_custom_settings !== branch.has_custom_settings){
			data.has_custom_settings = branch.has_custom_settings
		}

		dispatch({type: "WAIT_FOR_RESPONSE"})
		return axios.patch(`${URL + company.id}/branches/${branch.id}`, data).then( (res) => {

			localStorage.setItem("activeBranch", JSON.stringify(res.data ))
			Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
			// dispatch({
			// 	type: 'UPDATE_BRANCH',
			// 	branch: {
			// 		...res.data,
			// 		settings: branch.settings
			// 	},
			// 	initialBranch: {
			// 		...res.data,
			// 		settings: branch.settings
			// 	}
			// })
		})
		.catch((err) => {
			if(err.message && err.message !== 'generic')
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
			else
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
		});
	}
}

const updateBranchPayment = (bankTransferForms, pmForms) => {
	return (dispatch,getState) => {
		let { company, json_lang,branch } = getState();

		let branchData = branch;

		let newBankTransferData = []
        let newPmData = []
		let data = []

		if(bankTransferForms.length > 0){
			newBankTransferData = bankTransferForms.map(banks => ({
				bank_name: banks.bank_name,
				document: `${banks.document_prefix}${banks.document}`,
				account: banks.account,
				name: banks.name,
				email: banks.email || '',
				type: banks.type
			}))
			data = [...data, ...newBankTransferData];
		}

		if(pmForms.length > 0){
			newPmData = pmForms.map(banks => ({
				bank_code: banks.bank_code,
				document: `${banks.document_prefix}${banks.document}`,
				phone: `${banks.phone_prefix}${banks.phone}`,
				email: banks.email || '',
				type: banks.type
			}))
			data = [...data, ...newPmData]
		}

		dispatch({type: "WAIT_FOR_RESPONSE"})
		return axios.patch(`${URL + company.id}/branches/${branch.id}/settings`, { payout_accounts: data }).then( (res) => {
			branchData.settings = res.data;
			let update = branchData;
			localStorage.setItem("activeBranch", JSON.stringify(update))
			Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
			dispatch({
				type: 'UPDATE_BRANCH',
				branch: update,
				initialBranch: update
			})
		})
		.catch((err) => {
			if(err.message && err.message !== 'generic')
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
			else
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
		});
	}
}

const updateBranchSetings = (settings2) => {
	return (dispatch,getState) => {
		let { company, json_lang,branch, initialBranch } = getState();
		let newDate = Number(branch.settings.mark_too_busy_until);
		let minutesDifferenceSetting = branch.settings.minutes_difference ? branch.settings.minutes_difference : null;
		if(newDate && newDate !== 0){
			let actualDate = new Date();
			actualDate = new Date(actualDate.getTime() + newDate);
			newDate = actualDate.toISOString();
			let minutesDifference = Math.floor(branch.settings.mark_too_busy_until / (1000 * 60));
			minutesDifferenceSetting = minutesDifference;
		} else {
			newDate = null;
			minutesDifferenceSetting = null;
		}
		const settings = {
			uid: branch.settings.uid,
			enable_work_schedules: branch.settings.enable_work_schedules,
			auto_sync_work_schedules: branch.settings.auto_sync_work_schedules,
			human_min_checkout_price_e2: branch.settings.human_min_checkout_price_e2,
			order_expiration_minutes: branch.settings.order_expiration_minutes,
			payments_mode: branch.settings.payments_mode,
			max_scheduling_days: branch.settings.max_scheduling_days,
			pool_mode: branch.settings.pool_mode ? "company" : "branch",
			auto_assign_driver_upon_payment: branch.settings.auto_assign_driver_upon_payment,
			max_simultaneous_deliveries: Number(branch.settings.max_simultaneous_deliveries),
			mark_too_busy_until : newDate,
			auto_busy_quantity : Number(branch.settings.auto_busy_quantity),
			is_pool_automatic : branch.settings.is_pool_automatic,
			inventory_reminder_delay: branch.settings.inventory_reminder_delay
		}

		// console.log("---->settings",data.settings.enable_work_schedules, settings2.auto_sync_work_schedules)
        // if(branch.settings.uid !== settings2.uid){
        //     data.settings.uid = branch.settings.uid
        // }

        // if(branch.settings.enable_work_schedules !== settings2.enable_work_schedules){
        //     data.settings.enable_work_schedules = branch.settings.enable_work_schedules
        // }

        // if(branch.settings.auto_sync_work_schedules !== settings2.auto_sync_work_schedules){
        //     data.settings.auto_sync_work_schedules = branch.settings.auto_sync_work_schedules
		// }
		// if (branch.settings.human_min_checkout_price_e2 !== settings2.human_min_checkout_price_e2) {
		// 	data.settings.human_min_checkout_price_e2 = branch.settings.human_min_checkout_price_e2
		// }

		// if (branch.settings.order_expiration_minutes !== settings2.order_expiration_minutes) {
		// 	data.settings.order_expiration_minutes = branch.settings.order_expiration_minutes
		// }

		// if (branch.settings.payments_mode !== settings2.payments_mode) {
		// 	data.settings.payments_mode = branch.settings.payments_mode
		// }

		// if (branch.settings.max_scheduling_days !== settings2.max_scheduling_days) {
		// 	data.settings.max_scheduling_days = branch.settings.max_scheduling_days
		// }
		// if (branch.settings.pool_mode !== settings2.pool_mode) {
		// 	data.settings.pool_mode =  branch.settings.pool_mode === true ? "company" : "branch"
		// }

		dispatch({type: "WAIT_FOR_RESPONSE"})
		return axios.patch(`${URL+company.id}/branches/${branch.id}/settings`, settings).then( (res) => {
			// localStorage.setItem("activeBranch", JSON.stringify(res.data ))
			Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
			dispatch({
				type: 'UPDATE_BRANCH',
				branch: {
					...branch,
					settings: {
						...branch.settings,
						...res.data,
						mark_too_busy_until: branch.settings.mark_too_busy_until,
						minutes_difference: minutesDifferenceSetting,
						pool_mode: res.data.pool_mode === "company"
					}
				},
				initialBranch: {
					...branch,
					settings: {
						...branch.settings,
						...res.data,
						mark_too_busy_until: branch.settings.mark_too_busy_until,
						minutes_difference: minutesDifferenceSetting,
						pool_mode: res.data.pool_mode === "company"
					}
				},
			})
		})
		.catch((err) => {
			if(err.message && err.message !== 'generic')
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
			else
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
		});
	}
}

const updateAutoAssignDriverUponPayment = (value) => {
	return (dispatch,getState) => {
		let { company, json_lang,branch } = getState();
		const settings = {
			auto_assign_driver_upon_payment: value
		}
		dispatch({type: "WAIT_FOR_RESPONSE"})
		return axios.patch(`${URL+company.id}/branches/${branch.id}/settings`, settings).then( (res) => {
			dispatch({
				type: 'UPDATE_BRANCH',
				branch: {
					...branch,
					settings: res.data
				},
				initialBranch: {
					...branch,
					settings: res.data
				}
			})
			Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
		})
		.catch((err) => {
			if(err.message && err.message !== 'generic')
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
			else
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
		});
	}
}

const updateBranchSetingsWorkSchedules = () => {
	return (dispatch,getState) => {
		let { company, json_lang,initialBranch,branch } = getState();
		let data={
			settings:{}
		}

		if(data.settings.auto_sync_work_schedules !== initialBranch.settings.auto_sync_work_schedules){
            data.settings.auto_sync_work_schedules = branch.settings.auto_sync_work_schedules
        }
		if(data.settings.enable_work_schedules !== initialBranch.settings.enable_work_schedules){
            data.settings.enable_work_schedules = branch.settings.enable_work_schedules
        }


		dispatch({type: "WAIT_FOR_RESPONSE"})
		return axios.patch(`${URL+company.id}/branches/${branch.id}/settings`, data.settings).then( (res) => {
			Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
			branch.settings = res.data
			branch.settings.pool_mode = res.data.pool_mode === "company" ? true : false

			let update = branch
			dispatch({
				type: 'UPDATE_BRANCH',
				branch: update,
				initialBranch: update
			})
		})
		.catch((err) => {
			if(err.message && err.message !== 'generic')
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
			else
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
		});
	}
}

const updateBranchCommercies = () => {
	return (dispatch,getState) => {
		let { company, json_lang,initialBranch,branch } = getState();

		let settings={}
		let initial = initialBranch.settings
		if(settings.service_fee_name !== initial.service_fee_name){
            settings.service_fee_name = branch.settings.service_fee_name
        }
		if(settings.human_order_tax_prc !== initial.human_order_tax_prc){
            settings.human_order_tax_prc = branch.settings.human_order_tax_prc
        }

        if(settings.human_service_fee_prc !== initial.human_service_fee_prc){
            settings.human_service_fee_prc = branch.settings.human_service_fee_prc
        }
        if(settings.human_delivery_discount_prc !== initial.human_delivery_discount_prc){
            settings.human_delivery_discount_prc = branch.settings.human_delivery_discount_prc
		}

		if(settings.order_expiration_minutes !== initial.order_expiration_minutes){
            settings.order_expiration_minutes = branch.settings.order_expiration_minutes
		}

		if(settings.human_order_tax_flat_e2 !== initial.human_order_tax_flat_e2){
            settings.human_order_tax_flat_e2 = branch.settings.human_order_tax_flat_e2
		}

		if(settings.human_service_fee_flat_e2 !== initial.human_service_fee_flat_e2){
            settings.human_service_fee_flat_e2 = branch.settings.human_service_fee_flat_e2
		}
		if(settings.islr_prc !== initial.islr_prc){
            settings.islr_prc = Number(branch.settings.islr_prc)
		}
		if(settings.iva_retention_prc !== initial.iva_retention_prc){
            settings.iva_retention_prc = Number(branch.settings.iva_retention_prc)
		}
		if(settings.is_special_contributor !== initial.is_special_contributor){
            settings.is_special_contributor = branch.settings.is_special_contributor
		}
		if(settings.is_payment_deduction_disabled !== initial.is_payment_deduction_disabled){
            settings.is_payment_deduction_disabled = branch.settings.is_payment_deduction_disabled
		}
		if(settings.legal_name_for_fiscal_docs !== initial.legal_name_for_fiscal_docs){
            settings.legal_name_for_fiscal_docs = branch.settings.legal_name_for_fiscal_docs
		}
		if(settings.email_for_fiscal_docs !== initial.email_for_fiscal_docs){
            settings.email_for_fiscal_docs = branch.settings.email_for_fiscal_docs
		}
		if(settings.address_for_fiscal_docs !== initial.address_for_fiscal_docs){
            settings.address_for_fiscal_docs = branch.settings.address_for_fiscal_docs
		}
		if(settings.is_digital_invoice_enabled !== initial.is_digital_invoice_enabled){
            settings.is_digital_invoice_enabled = branch.settings.is_digital_invoice_enabled
		}
		settings.service_app_modifiers = branch.settings.service_app_modifiers;
		/*[{
			name:"Servicio Nocturno",
			price_min_e2:0,
			order_fee_e2:100,
			client_fee_e2:50,
			order_fee_prc:0.1,
			client_fee_prc:0.05,
			hour_beg:"18:00",
			hour_end:"07:00",
			label:"Recargo Nocturo" // texto a mostrar en el Checkout
		}]*/
		dispatch({type: "WAIT_FOR_RESPONSE"})

		return axios.patch(`${URL+company.id}/branches/${branch.id}/settings`, settings).then( (res) => {

			branch.settings = res.data
			let update = branch
			update.settings.human_branch_fee_prc = update.settings.human_order_tax_prc-update.settings.human_service_fee_prc

			localStorage.setItem("activeBranch", JSON.stringify(update))
			Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });

			dispatch({
				type: 'UPDATE_BRANCH',
				branch: update,
				initialBranch: update
			})
		})
		.catch((err) => {
			if(err.message && err.message !== 'generic')
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
			else
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
		});
	}
}

const excelConfigUpdate = (mappingName) => {
	return (dispatch,getState) => {
		let { company, json_lang,branch } = getState();

		let updatedMapping = {}
		const mapping = branch.settings.import_config.mapping

		if (Object.keys(mappingName).length !== 0) {
			Object.keys(mapping).forEach(key => {
			  if (key in mappingName) {
				updatedMapping[mappingName[key]] = mapping[key];
			  } else {
				updatedMapping[key] = mapping[key];
			  }
			});
		}else{
			updatedMapping = mapping;
		}

		// let settings={}
		let initial = {
			import_config: {
				...branch.settings.import_config,
				mapping: updatedMapping
			}
		}

		// if(settings.human_order_tax_prc !== initial.human_order_tax_prc){
        //     settings.human_order_tax_prc = branch.settings.human_order_tax_prc
        // }

        // if(settings.human_service_fee_prc !== initial.human_service_fee_prc){
        //     settings.human_service_fee_prc = branch.settings.human_service_fee_prc
        // }
        // if(settings.human_delivery_discount_prc !== initial.human_delivery_discount_prc){
        //     settings.human_delivery_discount_prc = branch.settings.human_delivery_discount_prc
		// }

		// if(settings.order_expiration_minutes !== initial.order_expiration_minutes){
        //     settings.order_expiration_minutes = branch.settings.order_expiration_minutes
		// }

		dispatch({type: "WAIT_FOR_RESPONSE"})

		return axios.patch(`${URL+company.id}/branches/${branch.id}/settings`, initial).then( (res) => {

			branch.settings = res.data
			let update = branch
			update.settings.human_branch_fee_prc = update.settings.human_order_tax_prc-update.settings.human_service_fee_prc

			localStorage.setItem("activeBranch", JSON.stringify(update))
			Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });

			dispatch({
				type: 'UPDATE_BRANCH',
				branch: update,
				initialBranch: update
			})
		})
		.catch((err) => {
			if(err.message && err.message !== 'generic')
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
			else
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
		});
	}
}
const pushExcelImport = (data1) => {
	return (dispatch,getState) => {
		let { branch } = getState();
		var data = {...branch}
		data.settings.import_config.mapping = {
			...data.settings.import_config.mapping,
			[data1.key]:`${data1.key_name}${data1.key_option ? `:${data1.key_option}`:``}`
		}

		dispatch({
			type: 'UPDATE_BRANCH',
			initialBranch:getState().initialBranch,
			branch:data
		})
	}
}

const deleteExcelImport = (data1) => {
	return (dispatch,getState) => {
		let { branch } = getState();
		var data = {...branch}
		/*data.settings.import_config.mapping = {
			...data.settings.import_config.mapping,
			[data1.key]:`${data1.key_name}${data1.key_option ? `:${data1.key_option}`:``}`
		}*/
		delete data.settings.import_config.mapping[data1]
		dispatch({
			type: 'UPDATE_BRANCH',
			initialBranch:getState().initialBranch,
			branch:data
		})
	}
}

const updateBranchAddress = (state ) => {
	return (dispatch,getState) => {
		let { company, json_lang,branch } = getState();

		let data={
			domain:state.domain,
			address: state.address || branch.address,
			latitude_e6: branch.latitude_e6, // state.coords.lat || branch.latitude_e6,
			longitude_e6: branch.longitude_e6 // state.coords.lng || branch.longitude_e6
		}

		dispatch({type: "WAIT_FOR_RESPONSE"})
		return axios.patch(`${URL + company.id}/branches/${branch.id}`, data).then( (res) => {

			localStorage.setItem("activeBranch", JSON.stringify(res.data ))
			Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
			dispatch({
				type: 'UPDATE_BRANCH',
				branch: res.data,
				initialBranch: res.data
			})
		})
		.catch((err) => {
			if(err.message && err.message !== 'generic')
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
			else
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
		});
	}
}

const fetchBranchlist = (page=1,sort,search_query='') => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		let { company, json_lang } = getState();
		let url_host = `/branches?limit=16&page=${page}${sort? `&sort_by=${sort.columnName},${sort.direction}` :``}`;
		url_host += (search_query !== '') ? `&name=ilike ${search_query}` : '';
		return axios.get(`${URL + company.id+url_host}`).then((res) => {
			dispatch({
				type: "FETCH_BRANCHES_LIST",
				branchesList: res.data
			})
		}).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const fetchBranchlistForMap = () => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		let { company, json_lang } = getState();
		let url_host = `/branches/all`;
		return axios.get(`${URL + company.id+url_host}`).then((res) => {
			dispatch({
				type: "FETCH_BRANCHES_LIST_MAP",
				branchesListMap: res.data
			})
		}).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

/* const filterBranchStatus = (status) => {
    return (dispatch, getState) => {
			  const { branchesListMap } = getState();

				const mapBranches = branchesListMap.filter((branch) => {
					return branch.status === status;
				});

				dispatch({
					type: "FETCH_BRANCHES_LIST_MAP",
					branchesListMap: mapBranches,
				});
			}
} */

const bulkbranchesActions = (action,data) => {
    return (dispatch,getState) => {
        const { json_lang, company } = getState();
        let branchesIds = data.map( (branchs) => {
            return (branchs.id)
        })

        let updateData={
            ids:branchesIds
        }
		console.log("data",data,updateData)
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL+company.id}/branches/batch-action/set-${action}`,updateData ).then( (res) => {
			if(res.data[0].payload.error_code === "EA174"){
                Notification.show({type: "error", title:json_lang.common.error, msg:"No se puede colocar en servicio comercios sin stock en el inventario."});
			}else if(res.data[0].payload.error_code === "EA170"){
                Notification.show({type: "error", title:json_lang.common.error, msg:"No se puede colocar en servicio comercios que no esten habilitados."});
			}else if(res.data[0].payload.error_code === "EF607"){
                Notification.show({type: "error", title:json_lang.common.error, msg:"No se puede colocar en servicio comercios que no tengan métodos de pago configurados."});
			}else if(res.data[0].payload.error_code === "EA180"){
                Notification.show({type: "error", title:json_lang.common.error, msg:"No se puede colocar en servicio comercios que no tengan administradores en línea."});
			}else if(res.data[0].payload.error_code === "EA172"){
                Notification.show({type: "error", title:json_lang.common.error, msg:"Este comercio no está en servicio."});
			}else{
                Notification.show({type: "success", title:json_lang.common.success, msg:json_lang.custom_success.update_successful});
			}


            /*let newdata= res.data.map( (item) => {
                return item.payload
            })*/
            // let errors = 0;
           /* newdata.forEach( (item) => {
                if(item.id){
                    let index = goodsList.findIndex(good => good.id === item.id)
                    goodsList[index] = item
                }else{
                    errors++
                    Notification.show({type: "error", title:`Error ${item.error_code}`, msg: item.description });

                }
                //console.log("azuk",goodsList);
            })*/
            // if(errors === 0){
            //     Notification.show({type: "success", title:json_lang.common.success, msg:json_lang.custom_success.update_successful});
            // }

			dispatch({type: "REMOVE_LOADING"});
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.update_categories_product});
        });
    }
}

const fetchBranchGroups = (page=1,query) => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		let { company, json_lang } = getState();
		//?limit=0

		query= query ? `&name=ilike ${encodeURIComponent(query)}`:''

		return axios.get(`${URL + company.id}/branch-groups?limit=10&sort_by=name,asc&page=${page}${query}`)
		.then((res) => {
			dispatch({
				type: "FETCH_BRANCH_GROUPS",
				branchGroups: res.data
			})
		}).catch((err) => {
				if(err.message && err.message !== 'generic')
						Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
				else
						Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
		});
  }
}

const fetchBranchGroupsByIds = (limit=10,ids='') => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		let { company, json_lang } = getState();

		return axios.get(`${URL + company.id}/branch-groups?limit=${limit}&page=1&id=:in:${ids}`)
		.then((res) => {
			dispatch({
				type: "FETCH_BRANCH_GROUPS_IDS",
				branchGroupsByIds: res.data.data
			})
		}).catch((err) => {
				if(err.message && err.message !== 'generic')
						Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
				else
						Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
		});
  }
}

const clearBranchGroupsByIds = () => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		dispatch({
			type: "FETCH_BRANCH_GROUPS_IDS",
			branchGroupsByIds: []
		})
  }
}

const fetchBranchGroup= (id) => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		let { company, json_lang } = getState();

		return axios.get(`${URL + company.id}/branch-groups/${id}/branches?limit=0`).then((res) => {
			dispatch({
				type: "FETCH_BRANCH_GROUP_LIST",
				branchGroupList: res.data
			})
		}).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const AddBranchInGroup= (id) => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		let { company, newBranch, json_lang,branchGroupList } = getState();
		let theBranch = {
		    name: newBranch.name,
		    description: newBranch.description,
		    address: "n/a",
		    phone: newBranch.phone,
			domain: newBranch.domain,
		    time_zone_offset: newBranch.time_zone_offset?newBranch.time_zone_offset:DEFAULT_TIME_ZONE,
		    latitude_e6: 0,
		    longitude_e6: 0,
			city_id: newBranch.city_id || null
		}

		return axios.post(`${URL + company.id}/branch-groups/${id}/branches`,theBranch).then((res) => {
			Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
			let update= branchGroupList.concat(res.data)
			dispatch({
				type: "FETCH_BRANCH_GROUP_LIST",
				branchGroupList: update
			})
		}).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const AddBranchGroup= () => {
	return (dispatch, getState) => {
			dispatch({type: "WAIT_FOR_RESPONSE"})
			let { company, json_lang,branchGroupData ,branchGroups} = getState();
			let theBranchG = {
				name: branchGroupData.name,
				display_unavailable_goods: branchGroupData.display_unavailable_goods,
				enable_shoppers: branchGroupData.enable_shoppers,
				is_market: branchGroupData.is_market,
				promo_label: branchGroupData.promo_label,
				display_spent_goods: branchGroupData.display_spent_goods,
				enable_auto_image_search: branchGroupData.enable_auto_image_search,
				enable_pool: branchGroupData.enable_pool,
				description: branchGroupData.description,
				group_description: branchGroupData.group_description,
			}
			if(branchGroupData.settings){
				theBranchG.settings = { ...branchGroupData.settings };
			}
			if(branchGroupData.domain){
				theBranchG.domain = encodeURIComponent(branchGroupData.domain);
				return axios.post(`${URL + company.id}/branch-groups`,theBranchG).then((res) => {
					Notification.show({type: "success", title:json_lang.common.success, msg:json_lang.custom_success.update_successful});

					console.log('res data update', res.data)
					console.log('branchGroups update', branchGroups)
					//let update= branchGroups.data.concat(res.data)
					branchGroups.data.unshift(res.data);
					console.log("update concat", branchGroups);
					dispatch({
						type: "FETCH_BRANCH_GROUPS",
						branchGroups: branchGroups
					})
				}).catch((err) => {
					if(err.message && err.message !== 'generic')
						Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
					else
						Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
				});
			}
    }
}

const EditBranchGroup= (id) => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		let { company, json_lang,branchGroupData} = getState();
		let theBranchG = {
			name: branchGroupData.name,
		    display_unavailable_goods: branchGroupData.display_unavailable_goods,
		    enable_shoppers: branchGroupData.enable_shoppers,
		    is_market: branchGroupData.is_market,
		    promo_label: branchGroupData.promo_label,
			domain: encodeURIComponent(branchGroupData.domain),
		    display_spent_goods: branchGroupData.display_spent_goods,
			is_digital: branchGroupData.is_digital,
		    enable_pool: branchGroupData.enable_pool,
			description: branchGroupData.description,
			group_description: branchGroupData.group_description,
			settings:{
				template: branchGroupData.settings.template,
				int_sku_enabled: branchGroupData.settings.int_sku_enabled,
				is_food_vendor: branchGroupData.settings.is_food_vendor,
				enable_auto_image_search: branchGroupData.settings.enable_auto_image_search,
				market_type: branchGroupData.settings.market_type || null,
				enable_shopper_validation: branchGroupData.settings.enable_shopper_validation
			}
		}
		return axios.patch(`${URL + company.id}/branch-groups/${id}`,theBranchG).then((res) => {
			Notification.show({type: "success", title:json_lang.common.success, msg:json_lang.custom_success.update_successful});

			/* let update= branchGroups.map( (branchGroup,key) => {
				if(branchGroup.id===id){
					branchGroup = res.data
				}
				return branchGroup
			}) */

			/*branchGroups[indexX] = res.data;
			let update = branchGroups
			console.log("update",update)*/
			/* dispatch({
				type: "FETCH_BRANCH_GROUPS",
				branchGroups: update
			}) */
		}).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const EditBranchGroupSettings= (id) => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		let { company, json_lang,branchGroupData ,branchGroups} = getState();
		let settings={
			template: branchGroupData.settings.template,
			color_accent: branchGroupData.settings.color_accent,
			color_primary: branchGroupData.settings.color_accent,
			int_sku_enabled: branchGroupData.settings.int_sku_enabled,
			is_food_vendor: branchGroupData.settings.is_food_vendor,
			enable_auto_image_search: branchGroupData.settings.enable_auto_image_search,
			market_type: branchGroupData.settings.market_type || null,
			enable_shopper_validation: branchGroupData.settings.enable_shopper_validation,
		}
		return axios.patch(`${URL + company.id}/branch-groups/${id}/settings`,settings).then((res) => {
			Notification.show({type: "success", title:json_lang.common.success, msg:json_lang.custom_success.update_successful});
			dispatch({
				type: "FETCH_BRANCH_GROUPS",
				branchGroups: branchGroups
			})
		}).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const ClearBranchGroup= () => {
	return (dispatch, getState) => {
		let update = {
			name: "",
		}
		dispatch({
			type: "FETCH_BRANCH_GROUP_DATA",
			branchGroupData: update
		})
    }
}

const clearBranchGroupSettings= () => {
	return (dispatch, getState) => {
		let update = {
			settings: {},
		}
		dispatch({
			type: "FETCH_BRANCH_GROUP_DATA_SETTINGS",
			branchGroupSettings: update
		})
    }
}

const DeleteBranchGroup = (branchGroupId) => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		let { company, branchGroups, branchGroupList, json_lang } = getState();
		return axios.delete(`${URL+company.id}/branch-groups/${branchGroupId}`).then((res) => {
			let updatedBranchGroupsList = [];
			if(branchGroupList){
				updatedBranchGroupsList = branchGroupList.filter( (item) => {
				    return (branchGroupId !== item.id);
				})
			}
			Notification.show({
				type: "success",
				title: json_lang.common.success,
				msg: json_lang.custom_success.delete_successful
			});
			// let updatedBranchGroups = branchGroups.data.filter((item) => {
			// 	return (branchGroupId !== item.id);
			// })
			// console.log('updatebranch delete', updatedBranchGroups)
			// dispatch({
			// 	type: "DELETE_BRANCH_GROUP",
			// 	branchGroupList: updatedBranchGroupsList,
			// 	branchGroups: updatedBranchGroups,
			// 	hasDeletedSuccessfully: true
			// })
		}).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const fetchBranch = (id) => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		let { company, branch, json_lang } = getState();

		return axios.get(`${URL+company.id}/branches/${(id || branch.id)}`).then((res) => {

			let update = res.data
			update.settings.human_branch_fee_prc = update.settings.human_order_tax_prc - update.settings.human_service_fee_prc

			dispatch({
				type: "FETCH_BRANCH",
				branch: res.data,
				initialBranch: res.data,
			})
		}).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const fetchBranchSettings = (id) => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		let { company, branch, json_lang } = getState();

		return axios.get(`${URL+company.id}/branches/${(id || branch.id)}/settings`).then((res) => {

			branch.settings = res.data
			let update = branch
			let newDate = update.settings.mark_too_busy_until;
			if (newDate) {
				let date = new Date(newDate);
				let actualDate = new Date();
				let timeDifference = date - actualDate;

				let closestTime = MIN_LIST.reduce((prev, curr) => {
					return Math.abs(curr.value - timeDifference) < Math.abs(prev.value - timeDifference) ? curr : prev;
				});

				let minutesDifference = Math.floor(timeDifference / (1000 * 60));
				update.settings.minutes_difference = minutesDifference > 0 ? minutesDifference : null;

				newDate = closestTime.value;
			}
			update.settings.human_branch_fee_prc = update.settings.human_order_tax_prc-update.settings.human_service_fee_prc
			update.settings.pool_mode = res.data.pool_mode === "company";
			update.settings.mark_too_busy_until = newDate;


			dispatch({
				type: "FETCH_BRANCH",
				branch: update,
				initialBranch: update,
			})
		}).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const DeleteBranch = (id) => {
	return (dispatch, getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		let { company, branchGroupList, json_lang } = getState();
		return axios.delete(URL + company.id + '/branches/' +id).then((res) => {
			let update = branchGroupList.filter( (item) => {
			    return (id !== item.id);
			})
			Notification.show({
				type: "success",
				title: json_lang.common.success,
				msg: json_lang.custom_success.delete_successful
			});
			dispatch({
				type: "FETCH_BRANCH_GROUP_LIST",
				branchGroupList: update
			})
		}).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const fetchCompanyBranches = (limit=10,query,page=1,loader=true) => {
	return (dispatch, getState) => {
		if(loader) dispatch({type: "WAIT_FOR_RESPONSE"})
		let { company, json_lang,branches } = getState();
		return axios.get(`${URL + company.id}/branches?with=city&page=${page}&limit=${limit}${query ? `&name=ilike ${encodeURIComponent(query)}` :``}`).then((res) => {
			let response = res.data.data
			dispatch({
				type: "FETCH_BRANCHES",
				branches: response
			})
		}).catch((err) => {
			Notification.show({
				type: "error",
				title:`Error ${err && err.data && err.data.error_code}`,
				msg: err.message && err.message !== 'generic' ? err.message : json_lang.custom_errors.company_update_failed
			});
        });
    }
}
const fetchProviderBranchAccesses = (ids) => {
	return (dispatch, getState) => {
		let { company, json_lang } = getState();
		return axios.get(`${URL + company.id}/branches?with=city&id=:in:${ids.join(',')}`).then((res) => {
			dispatch({
				type: "FETCH_PROVIDER_BRANCHES_ACCESSES",
				providerBranchAccesses: res.data.data
			})
		}).catch((err) => {
			Notification.show({
				type: "error",
				title:`Error ${err && err.data && err.data.error_code}`,
				msg: err.message && err.message !== 'generic' ? err.message : json_lang.custom_errors.company_update_failed
			});
        });
    }
}

const searchBranchesByCity = (id) => {
    return (dispatch,getState) => {
        const { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL + company.id}/branches?city_id=${id}`).then((res) => {
			dispatch({
				type: "FETCH_BRANCHES",
				branches: res.data
			})
		}).catch((err) => {
			Notification.show({
				type: "error",
				title:`Error ${err && err.data && err.data.error_code}`,
				msg: err.message && err.message !== 'generic' ? err.message : json_lang.custom_errors.retrieving_user_list
			});
		});
    }
}


const toggleBranchEnabledStatus = (branch_id, status, isFromAllBranch) => {
	return (dispatch,getState) => {
		let { company, json_lang, branchesList } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})

		return axios.post(URL + company.id + '/branches/' + branch_id + '/set-' + (!status ? 'disabled' : 'enabled') )
			.then( res => {
				if(isFromAllBranch){
					return
        // TODO: Por ahora coloco retorno, ya que el componente no se esta actualizando a pesar de que se setea un nuevo estados

					// const index = branchesList.data.findIndex(branch => branch.id === res.data.id)
					// let branches_list = branchesList;
					// branches_list.data[index] = res.data;
                    // branches_list.data = [...branches_list.data]

					// dispatch({
					// 	type: "FETCH_BRANCHES_LIST",
					// 	branchesList: branches_list
					// })
				}else{
					dispatch({
						type: "FETCH_BRANCH_GROUP_LIST",
						branchGroupList: tableUpdate(res, "branchGroupList")
					})
				}
				Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
			})
			.catch((err) => {
				if(err.message && err.message !== 'generic')
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
				else
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
			});
    }
}

const toggleBranchVisibleStatus = (branch_id, status, isFromAllBranch) => {
	return (dispatch,getState) => {
		let { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})

		return axios.post(URL + company.id + '/branches/' + branch_id + '/set-' + (!status ? 'hidden' : 'visible') )
			.then( res => {
				if(isFromAllBranch){
					return;
				} else {
					dispatch({type: "WAIT_FOR_RESPONSE"})
					dispatch({
						type: "FETCH_BRANCH_GROUP_LIST",
						branchGroupList: tableUpdate(res, "branchGroupList")
					})
				}
				Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });

			})
			.catch((err) => {
				if(err.message && err.message !== 'generic')
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
				else
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
			});
    }
}

const toggleBranchServiceStatus = (branch_id, status, isFromAllBranch) => {
	return (dispatch,getState) => {
		let { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})

		return axios.post(URL + company.id + '/branches/' + branch_id + '/set-' + (!status ? 'in-service-disabled' : 'in-service-enabled') )
			.then( res => {
				if(isFromAllBranch){
					return;
				}else{
					dispatch({type: "WAIT_FOR_RESPONSE"})
					dispatch({
						type: "FETCH_BRANCH_GROUP_LIST",
						branchGroupList: tableUpdate(res, "branchGroupList")
					})
				}
				Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
			})
			.catch((err) => {
				if(err.data){
					switch(err.data.error_code){
						case "EA170":
							Notification.show({ type: "error", title:"Error", msg:"No se puede colocar en servicio comercios que no estén habilitados." });
							break;
						case "EA174":
							Notification.show({ type: "error", title:"Error", msg:"No se puede colocar en servicio comercios sin stock en el inventario." });
							break;
						case "EF607":
							Notification.show({ type: "error", title:"Error", msg:"No se puede colocar en servicio comercios que no tengan métodos de pago configurados." });
							break;
						case "EA180":
							Notification.show({ type: "error", title:"Error", msg:"No se puede colocar en servicio comercios que no tengan administradores en línea." });
							break;
						case "EA172":
							Notification.show({ type: "error", title:"Error", msg:"Este comercio no está en servicio." });
							break;
						default:
							if(err.message && err.message !== 'generic')
								Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
							else
								Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
							break;
					}
				}else{
					if(err.message && err.message !== 'generic')
						Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
					else
						Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
				}
			});
    }
}

const updateSelectedBranch = (userBranch) => {
	return (dispatch, getState) => {
		let { company, json_lang, branch ,userHigherAccess} = getState();
		if ( (userBranch && userBranch.id) || (branch && branch.id) ){
			dispatch({type: "WAIT_FOR_RESPONSE"})
			localStorage.setItem('activeBranch', JSON.stringify( userBranch ));

			return axios.get(`${URL+company.id}/branches/${(userBranch.id || branch.id)}${ userHigherAccess === COMPANY_ACCESS ? `/settings` : `` }`).then((res) => {

				userBranch.settings = res.data
				let update = userBranch
				update.settings.human_branch_fee_prc = update.settings.human_order_tax_prc-update.settings.human_service_fee_prc

				localStorage.setItem('activeBranch', JSON.stringify( userBranch ));
				dispatch({
					type: "FETCH_BRANCH",
					branch: userBranch,
					initialBranch: userBranch,
				})
			}).catch((err) => {
	            if(err.message && err.message !== 'generic')
	                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
	            else
	                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
	        });
		}
		else{

			localStorage.setItem('activeBranch', JSON.stringify( {} ));
			dispatch({
				type: "FETCH_BRANCH",
				branch: userBranch,
				initialBranch: userBranch,
			})
		}
	}
}
/*
const updateCompanyInformation = () => {
    return (dispatch,getState) => {
        let { branch,initCompany,company } = getState();
        let data = {
            settings:{}
        }

        if(initCompany.options !== branch.options){
            data.options = branch.options
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL+company.id}`, data).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful} );
            dispatch({
				type: "FETCH_BRANCH",
				branch: res.data,
				initialBranch: res.data,
			})
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}
*/

const toggleData = (value) => {
	return (dispatch, getState) => {
		//let {branch, editable_company_settings,initialBranch} = getState();
		var data = {...getState().branch}
		//let settingsX = value.name && value.name.split('_setting');
		let option = "";
		if(value && value.name && value.name.split("-")){
			option = value && value.name.split("-")
		}

		if (value.name === 'in_service') {
			data.in_service = value.checked === true ? true : false;
		}
		/* else if (value.name === 'enable_multi_providers') {
			editable_company_settings.enable_multi_providers = !editable_company_settings.enable_multi_providers;

		}*/
		else if (value.name === 'uid') {
			data.settings.uid = value.data;

		} else if (value.longitude_e6 || value.latitude_e6) {

			data.longitude_e6 = value.longitude_e6;
			data.latitude_e6 = value.latitude_e6;

		} else if(
			value.name === 'human_service_fee_prc'
			|| value.name === 'human_branch_fee_prc'
			|| value.name === 'human_service_fee_flat_e2'
			|| value.name === 'human_order_tax_flat_e2'
			|| value.name === 'max_simultaneous_deliveries'
			|| value.name === 'mark_too_busy_until'
			|| value.name === 'auto_busy_quantity'
			|| value.name === 'legal_name_for_fiscal_docs'
			|| value.name === 'islr_prc'
			|| value.name === 'iva_retention_prc'
			|| value.name === 'address_for_fiscal_docs'
			|| value.name === 'email_for_fiscal_docs'
		){
			data.settings[value.name] =  value.data;
			data.settings["human_order_tax_prc"] =
				parseFloat(FloatPrecision(data.settings.human_branch_fee_prc))
				+
				parseFloat(FloatPrecision(data.settings.human_service_fee_prc))
				//( !Number.isNaN(editable_company_settings.human_service_fee_prc) ? editable_company_settings.human_service_fee_prc : 0)
			;
		}
		else if ( value.name === 'human_delivery_discount_prc' || value.name === 'order_expiration_minutes')  {
			data.settings[value.name] = parseFloat(value.data);
		}
		else if( value.name === 'human_min_checkout_price_e2' || value.name === 'payments_mode' || value.name === 'max_scheduling_days' || value.name === 'service_fee_name'){
			data.settings[value.name] = value.data;
		}
		else if (
			value.name === 'pool_mode'
			|| value.name === 'enable_work_schedules'
			|| value.name === 'auto_sync_work_schedules'
			|| value.name === 'is_special_contributor'
			|| value.name === 'is_payment_deduction_disabled'
			|| value.name === 'is_digital_invoice_enabled'
			|| value.name === 'is_pool_automatic'
		){
			data.settings[value.name] = value.checked;
		}
		else if(option.length >1){
            var mValue = parseInt(value.data,10)

            if((mValue&768)!==0){
                //alternar donde se coincinde los pick ups o delivery para q almenos uno este selectionados
                data.options &= ~(768 ^ mValue)
                mValue |= 256
            }

            if((mValue&(768 << 12))!==0){
                //alternar donde se coincinde los pick ups o delivery para q almenos uno este selectionados
                data.options &= ~((768 << 12) ^ mValue)
                mValue |= (256 << 12)
            }

            data.options ^= mValue
        }else if(value.name === 'refresh_data' || value.name === 'clear_missing' || value.name === 'debug' || value.name === 'check_in_service'){
			data.settings.import_config.config[value.name] = value.checked === true ? true : false;
		}else if(value.name === 'starting_cell' || value.name === 'currency' || value.name === 'quantity_threshold' || value.name === 'quantity_reservation'){
			if(data.settings && data.settings.import_config && data.settings.import_config.config){
				data.settings.import_config.config[value.name] = value.value;
			}
		}
		/*else if(settingsX && settingsX.length >1){
			console.log(
				"test",
				settingsX[1],
				settingsX[0],
				data.settings.delivery_fee_steps,
				data.settings.delivery_fee_steps[settingsX[1]][settingsX[0]],
				value,
				value.checked
			);

			console.log("is_additional",settingsX[0] === "is_additional")
			settingsX[0] === "is_additional" ?
			data.settings.delivery_fee_steps[settingsX[1]][settingsX[0]] = value.checked
			:
			data.settings.delivery_fee_steps[settingsX[1]][settingsX[0]] = value.data
        }*/
		else if(value.type){
			const firstOption = data.settings.import_config.mapping[value.name].split(":").length> 1 ?
				data.settings.import_config.mapping[value.name].split(":")[0]
				:
				data.settings.import_config.mapping[value.name];
			const secondOption =  data.settings.import_config.mapping[value.name].split(":")[1] ?
				data.settings.import_config.mapping[value.name].split(":")[1]
				:''
			if(value.type === 'key'){
				data.settings.import_config.mapping[value.name] = secondOption ? value.value + `:${secondOption}` : value.value
			}else{
				data.settings.import_config.mapping[value.name] = firstOption + `:${value.value}`
			}

		}

		else if(value.name === 'has_custom_settings'){
			data.has_custom_settings = !value.checked
		}else if(value.name === "auto_assign_driver_upon_payment"){
			data.settings.auto_assign_driver_upon_payment = value.checked;
		} else if (value.name === "inventory_reminder_delay"){
			console.log("value ====> ",value)
			if(value.checked){
				data.settings.inventory_reminder_delay = 72;
			} else {
				data.settings.inventory_reminder_delay = 0;
			}
		}
		
		else {
			data[value.name] = value.data;
		}
		//console.log("import_config",data.settings.import_config)
		dispatch({
			type: 'UPDATE_BRANCH',
			initialBranch:getState().initialBranch,
			branch:data
		})
	}
}

const toggleData2 = (value) => {
	return (dispatch, getState) => {
		let {branch, editable_company_settings} = getState();

		branch[value.name] = value.data;

		dispatch({
			type: 'UPDATE_BRANCH',
			branch,
			editable_company_settings
		})
	}
}

const toggleDataBranchFeeds = (value) => {
	return (dispatch,getState) => {
		var data = [
			...getState().branchDeliveryFees,
		]
		let settingsX = value.name.split('_setting');
		data[settingsX[1]][settingsX[0]] = settingsX[0] === "is_additional" ? value.checked : value.data;

		dispatch({
			type: 'BRANCH_DELIVERY_FEEDS',
			branchDeliveryFees: data
		})
	}
}


const toggleData4 = (value) => {
	return (dispatch, getState) => {
		let {newBranch } = getState();

		newBranch[value.name] = value.data;

		dispatch({
			type: 'UPDATE_NEWBRANCH',
			newBranch,
		})
	}
}


const clearNewBranch = (value) => {
	return (dispatch, getState) => {
		let { editable_company_settings } = getState();
		let update={
			name:"",
			description:"",
			address:"",
			phone:"",
			time_zone_offset:"",
		}
		dispatch({
			type: 'UPDATE_NEWBRANCH',
			newBranch:update,
			editable_company_settings
		})
	}
}
const clearBranch = (value) => {
	return (dispatch, getState) => {
		let { editable_company_settings } = getState();
		let update={
			name:"",
			description:"",
			address:"",
			phone:"",
			time_zone_offset:"",
		}
		dispatch({
			type: 'UPDATE_BRANCH',
			branch:update,
			editable_company_settings
		})
	}
}

const toggleData3 = (value) => {
	return (dispatch, getState) => {
		let {branchGroupData } = getState();
		let data = {...branchGroupData};
		if (value.name === 'is_digital' ||
		value.name === 'display_spent_goods' ||
		value.name === 'enable_shoppers' ||
		value.name === 'is_market' ||
		value.name === 'display_unavailable_goods' ||
		value.name === 'enable_pool') {
			data[value.name] = value.checked;
		}else if(value.name === 'template' || value.name === 'color_accent' || value.name === 'market_type'){
			if(data && data.settings){
				data.settings[value.name] = value.data;
			}else{
				data.settings = {};
				data.settings[value.name] = value.data;
			}

		}else if(value.name === 'enable_auto_image_search' ||
			value.name === 'int_sku_enabled' ||
			value.name === 'enable_shopper_validation' ||
			value.name === 'is_food_vendor'){
				data.settings[value.name] = value.checked;
		}else{
			data[value.name] = value.data;
		}

		dispatch({
			type: 'FETCH_BRANCH_GROUP_DATA',
			branchGroupData:data
		})
	}
}

const updateBranchInServiceStatus = (enabled) => {
    return (dispatch,getState) => {
		let { company, json_lang, branch } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
		// cuando llega aqui branch.in_service ya viene seteada con el valor contrario al q tiene el api... por eso se niega con !branch.in_service
		return axios.post(`${URL+company.id}/branches/${branch.id}/set-in-service-${enabled ? 'enabled' : 'disabled' }`)
			.then( res => {
				dispatch({type: "WAIT_FOR_RESPONSE"})
				dispatch({
					type: "FETCH_BRANCH",
					branch: res.data
				})
				localStorage.setItem("activeBranch", JSON.stringify(res.data))
				Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
			})
			.catch((err) => {
				if(err.message && err.message !== 'generic')
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
				else
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
			});
    }
}

const toggleBranchInFeature = (branch_id, status, isFromAllBranch) => {
	return (dispatch,getState) => {
		let { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})

		return axios.post(URL + company.id + '/branches/' + branch_id + '/set-featured-' + (!status ? 'disabled' : 'enabled') )
			.then( res => {
				if(isFromAllBranch){
					return;
				}else{
					dispatch({type: "WAIT_FOR_RESPONSE"})
					dispatch({
						type: "FETCH_BRANCH_GROUP_LIST",
						branchGroupList: tableUpdate(res, "branchGroupList")
					})
				}
				Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
			})
			.catch((err) => {
				if(err.message && err.message !== 'generic')
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
				else
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
			});
    }
}

const accesessss = (id) => {
    return (dispatch,getState) => {
		let { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
		// cuando llega aqui branch.in_service ya viene seteada con el valor contrario al q tiene el api... por eso se niega con !branch.in_service
		return axios.get(`${URL+company.id}/branches/${id}/admin-accesses?limit=0&with=admin`).then( res => {
				//dispatch({type: "WAIT_FOR_RESPONSE"})
				dispatch({
					type: "FETCH_ADMINS_ACCESS",
					admindAccessList: res.data
				})
			})
			.catch((err) => {
				if(err.message && err.message !== 'generic')
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
				else
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
			});
    }
}
const getBrancchGroupAcceses = (id) => {
    return (dispatch,getState) => {
		let { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
		// cuando llega aqui branch.in_service ya viene seteada con el valor contrario al q tiene el api... por eso se niega con !branch.in_service
		return axios.get(`${URL+company.id}/branch-groups/${id}/admin-accesses?limit=0&with=admin`).then( res => {
				//dispatch({type: "WAIT_FOR_RESPONSE"})
				dispatch({
					type: "FETCH_ADMINS_ACCESS",
					admindAccessList: res.data
				})
			})
			.catch((err) => {
				if(err.message && err.message !== 'generic')
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
				else
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
			});
    }
}
const Addaccesessss = (access_type,id,access_id) => {
    return (dispatch,getState) => {
		let { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        let data ={
			access_type: access_type,
			access_id: access_id
        }
		return axios.post(`${URL+company.id}/admins/${id}/admin-accesses`,data).then( res => {
				dispatch({
					type: "FETCH_ADMINS_ACCESS",
					admindAccessList: res.data
				})
				Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });

			})
			.catch((err) => {
				if(err.message && err.message !== 'generic')
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
				else
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
			});
    }
}

const DeleteAccesessss = (id) => {
    return (dispatch,getState) => {
		let { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
		return axios.delete(`${URL+company.id}/admin-accesses/${id}`).then( res => {
				dispatch({
					type: "FETCH_ADMINS_ACCESS",
					admindAccessList: res.data
				})
				Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });

			})
			.catch((err) => {
				if(err.message && err.message !== 'generic')
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
				else
					Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
			});
    }
}

const getBranchDeliveryFees = (branchId) => {
    return (dispatch, getState) => {
        const { company, json_lang} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL+company.id}/branches/${branchId}/delivery-fees?limit=0`).then((res) => {
            dispatch({
				type: 'BRANCH_DELIVERY_FEEDS',
				branchDeliveryFees: res.data,
			})
        }).catch((err) => {
			console.log("errerrerrerrerrerrerr",err)
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            /*else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });*/
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}


const getBranchRatings = (id) => {
    return (dispatch,getState) => {
		let { company } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
		return axios.get(`${URL+company.id}/branches/${id}/branch-ratings`).then( res => {
			dispatch({
				type: "FETCH_BRANCH_RATINGS",
				branchRatings: res.data
			})
		})
		.catch((err) => {
			console.log("fallo el traer los ratings",err)
		});
    }
}

const getOrderBranchRatings = (id,query='') => {
    return (dispatch,getState) => {
		let { company } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
		return axios.get(`${URL+company.id}/branches/${id}/branch-ratings${query}`).then( res => {
			dispatch({
				type: "FETCH_ORDER_BRANCH_RATINGS",
				orderBranchRatings: res.data
			})
		})
		.catch((err) => {
			console.log("fallo el traer los ratings",err)
		});
    }
}
const addBranchDeliveryFeeSteps = () => {
    return (dispatch,getState) => {
        const { branchDeliveryFees } = getState();
        let data = [...branchDeliveryFees];

        let step={
            name:"",
            distance_min:"",
            distance_max:"",
            human_fee_min_e2:"",
            human_fee_max_e2:"",
            human_delivery_providers_prc:"",
            hour_beg:"",
			hour_end:"",
            label:"",
            is_additional:false,
            days:[]
        }
        data.push(step);

        dispatch({
            type: 'BRANCH_DELIVERY_FEEDS',
            branchDeliveryFees: data,
        })
    }
}

const updatebranchDeliveryFeeSteps = (branch_id) => {
    return (dispatch,getState) => {
        const { company, branchDeliveryFees, json_lang } = getState();
		let data = [...branchDeliveryFees]

        let  theUpdate= data.map( (step,key) => {
			let update;
			if( step.name !== "" &&
				step.distance_min !== "" &&
				step.distance_max !== "" &&
				( step.human_fee_min_e2 !== "" && step.human_fee_min_e2 !== 0 ) &&
				( step.human_fee_max_e2 !== "" && step.human_fee_max_e2 !== 0 ) &&
				( step.human_delivery_providers_prc !=="" && step.human_delivery_providers_prc !== 0 )
			){

				update={
					name:step.name,
					distance_min:step.distance_min,
					distance_max:step.distance_max,
					human_fee_min_e2:step.human_fee_min_e2,
					human_fee_max_e2:step.human_fee_max_e2,
					human_delivery_providers_prc:step.human_delivery_providers_prc,
					hour_beg:step.hour_beg,
					hour_end:step.hour_end,
					is_additional:step.is_additional,
					label:step.label,
					days:[]
				}
			}
			return update
		}).filter((step) =>{
			return step !== undefined;
		})

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.put(`${URL+company.id}/branches/${branch_id}/delivery-fees`, theUpdate).then( (res) => {
			localStorage.setItem("activeBranch", JSON.stringify(res.data ))
			Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
			dispatch({
				type: 'BRANCH_DELIVERY_FEEDS',
				branchDeliveryFees: res.data,
			})
		})
    }
}


const deleteBranchDeliveryFeeSteps = (keyId) => {
    return (dispatch,getState) => {
        var data = {...getState().branch}
        let update = data.settings && data.settings.delivery_fee_steps.filter( (step,key) => key !== keyId);
        data.settings.delivery_fee_steps = update
        dispatch({
			type: 'UPDATE_BRANCH',
			branch: data,
			initialBranch: data
		})
    }
}

const getBranchCurrencies = ()=>{
    return (dispatch,getState) => {
		const { company, json_lang,branch} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL+company.id}/branches/${branch.id}/currencies?limit=0`).then( (res) => {
			let errorCurrencies = false;
            res.data.forEach( (curreny,key) => {
                if(curreny.related_iso_error === true){
                    errorCurrencies = true
                }
            })
            dispatch({
                type: 'FETCH_BRANCH_CURRENCIES',
                branchCurrencies: res.data,
				branchCurrencyError:errorCurrencies
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const clearBranchCurrency = () => {
    return (dispatch) => {
        dispatch({
            type: 'FETCH_BRANCH_CURRENCY',
            companyCurrency: {
                enabled:false,
                iso:"",
                symbol:"",
                conversion_factor:"",
                related_iso:"",
                decimals_count:0,
                format:"",
                decimal_point:"",
                use_thousands_separator:false,
                thousands_separator:"",
                is_local:false,
                is_international:false,
                use_conversion:false,
                available:false,
            }
        })
    }
}

const toogleBranchCurrency = (value) => {
    return (dispatch, getState) => {
        var data = {...getState().branchCurrency}
        if( value.name ==="enabled" ||
            value.name ==="available" ||
            value.name ==="use_thousands_separator" ||
            value.name ==="is_local" ||
            value.name ==="is_custom" ||
			value.name ==="auto_sync" ||
            value.name ==="is_international"){
            data[value.name] = value.checked;
        }else{
            data[value.name] = value.data;
        }

        dispatch({
            type: 'FETCH_BRANCH_CURRENCY',
            branchCurrency: data
        })
    }
}

const createBranchCurrency = () => {
    return (dispatch, getState) => {
        const { company, json_lang,branchCurrencies,branch,companyCurrency} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL+company.id}/branches/${branch.id}/currencies`,companyCurrency).then((res) => {
            let update = branchCurrencies.concat(res.data)
            dispatch({
                type: 'FETCH_BRANCH_CURRENCIES',
                branchCurrencies: update
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const getPriceList = () => {
    return (dispatch, getState) => {
        const { company, json_lang,branch,companyCurrency} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL+company.id}/branches/${branch.id}/price-lists?limit=0`,companyCurrency).then((res) => {
            /*let update = branchCurrencies.concat(res.data)*/
            dispatch({
                type: 'FETCH_BRANCH_PRICELIST',
                branchPriceList: res.data
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err && err.data && err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const getPriceListId = (id) => {
    return (dispatch, getState) => {
        const { company, companyCurrency} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});

        return axios.get(`${URL+company.id}/price-lists/${id}`,companyCurrency).then((res) => {
			/*let update = branchCurrencies.concat(res.data)*/
			let response = res.data
			/*response.price_adjustment_e2 = response.price_adjustment_e2*100;
			response.price_multiple_e2 = response.price_multiple_e2*100;*/

            dispatch({
                type: 'FETCH_BRANCH_PRICELIST_ID',
                priceListId: response
            })
        }).catch((err) => {

        });
    }
}

const storePriceList = () => {
    return (dispatch, getState) => {
        const { company, json_lang,branch,priceListId} = getState();
		dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL+company.id}/branches/${branch.id}/price-lists`,priceListId).then((res) => {
            /*let update = branchCurrencies.concat(res.data)
            dispatch({
                type: 'FETCH_BRANCH_PRICELIST',
                branchPriceList: res.data
            })*/
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const editPriceList = (id) => {
    return (dispatch, getState) => {
        const { company, json_lang,branchPriceList,priceListId} = getState();
		dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.patch(`${URL+company.id}/price-lists/${id}`,priceListId).then((res) => {
            /*let update = branchCurrencies.concat(res.data)*/
            dispatch({
                type: 'FETCH_BRANCH_PRICELIST',
                branchPriceList: branchPriceList
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const deletePriceList = (id) => {
    return (dispatch, getState) => {
        const { company, json_lang,branchPriceList} = getState();
		dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.delete(`${URL+company.id}/price-lists/${id}`,branchPriceList).then((res) => {
            /*let update = branchCurrencies.concat(res.data)
            dispatch({
                type: 'FETCH_BRANCH_PRICELIST',
                branchPriceList: res.data
            })*/
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const clearPriceList = () => {
	let clear = {}
	return (dispatch) => {
		dispatch({
			type: 'FETCH_BRANCH_PRICELIST_ID',
			priceListId: clear
		})
	}
}
const toggleDataPricelist = (value) => {
	return (dispatch, getState) => {
		let {priceListId } = getState();
		let data = {...priceListId};

		data[value.name] = value.data;

		dispatch({
			type: 'FETCH_BRANCH_PRICELIST_ID',
			priceListId: data
		})
	}
}

const toggleDataBranchServiceModifiers = (value) => {
	return (dispatch,getState) => {
		let data = {...getState().branch};
		let item = value.name.split('_service')[0];
		let key = value.name.split('_service')[1];

		data.settings.service_app_modifiers[key][item] = value.data;

		dispatch({
			type: 'UPDATE_BRANCH',
			branch: data,
			initialBranch: data
		})
	}
}

const addBranchServiceModifiers = () => {
    return (dispatch,getState) => {
        var data = {...getState().branch};

        let step={
            name:"",
			label:"",
            price_max_e2:"",
            price_min_e2:"",
            order_fee_e2:"",
            client_fee_e2:"",
            order_fee_prc:"",
			hour_beg:"",
			hour_end:""
        }

        data.settings.service_app_modifiers.push(step);

		dispatch({
			type: 'UPDATE_BRANCH',
			branch: data,
			initialBranch: data
		})
    }
}
const deleteBranchServiceModifiers = (keyId) => {
    return (dispatch,getState) => {
        var data = {...getState().branch}
        let update = data.settings && data.settings.service_app_modifiers.filter( (step,key) => key !== keyId);
        data.settings.service_app_modifiers = update
        dispatch({
			type: 'UPDATE_BRANCH',
			branch: data,
			initialBranch: data
		})
    }
}

const updateBranchPaymentEmails = (emails) => {
	return (dispatch, getState) => {
		const { company, branch, json_lang } = getState();
		const data = {
			emails_for_payments: emails
		}
		let branchData = branch;
		return axios.patch(URL + company.id + '/branches/' + branch.id + '/settings', data).then(res => {
			branchData.settings = res.data;
			let update = branchData;
			localStorage.setItem("activeBranch", JSON.stringify(update))
			Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
			dispatch({
				type: 'UPDATE_BRANCH',
				branch: update,
				initialBranch: update
			})
		}).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
	}
}

export const getWorkSchedulesForOrdering = (branchId) => {
	return (dispatch, getState) => {
		const { company, branch } = getState();
		return axios.get(URL + company.id + `/branches/${ branchId || branch.id}/work-schedules/for-ordering`)
			.then((res) => {
				dispatch({
					type: "GET_WORK_SCHEDULES_FOR_ORDERING",
					workSchedulesForOrdering: res.data
				});
			})
			.catch((err) => {
				Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err && err.data && err.data.description || "Error desconocido" });
			});
	}
}

export const getBranchHolidays = () => {
	return (dispatch, getState) => {
		const { company, branch,json_lang } = getState();
		return axios.get(URL + company.id + `/branches/${branch.id}/holidays?limit=0`)
			.then((res) => {
				dispatch({
					type: "BRANCH_HOLIDAYS",
					branchHolidays: res.data
				});
			})
			.catch((err) => {
				dispatch({ type: "ERROR_BRANCH_HOLIDAYS" });
				if(err.data){
					const error = localizedErrorHandler(err.data);
					Notification.show({
						type: "error", 
						title:`Error ${error.code}`, 
						msg: error.message
					});
				} else {
					Notification.show({
						type: "error", 
						title:`Error`, 
						msg: json_lang.two_steps_modal.default_error 
					});
				}
			});
	}
}

export const createBranchHoliday = (payload) => {
	return (dispatch, getState) => {
		const { company, branch,json_lang, branchHolidays } = getState();
		return axios.post(URL + company.id + `/branches/${branch.id}/holidays`,payload)
			.then((res) => {
				dispatch({
					type: "BRANCH_HOLIDAYS",
					branchHolidays: [...branchHolidays, res.data]
				});
				Notification.show({
					type: "success", 
					title:json_lang.common.success, 
					msg:json_lang.custom_success.saved_successful 
				});
			})
			.catch((err) => {
				if(err.data){
					const error = localizedErrorHandler(err.data);
					Notification.show({
						type: "error", 
						title:`Error ${error.code}`, 
						msg: error.message
					});
				} else {
					Notification.show({
						type: "error", 
						title:`Error`, 
						msg: json_lang.two_steps_modal.default_error 
					});
				}
			});
	}
}

export const updateBranchHoliday = (payload) => {
	return (dispatch, getState) => {
		const { company, json_lang, branchHolidays } = getState();
		return axios.patch(URL + company.id + `/holidays/${payload.id}`,payload)
			.then((res) => {
				dispatch({
					type: "BRANCH_HOLIDAYS",
					branchHolidays: branchHolidays.map((holiday) => holiday.id === payload.id ? res.data : holiday)
				});
				Notification.show({
					type: "success", 
					title:json_lang.common.success, 
					msg:json_lang.custom_success.update_successful 
				});
			})
			.catch((err) => {
				if(err.data){
					const error = localizedErrorHandler(err.data);
					Notification.show({
						type: "error", 
						title:`Error ${error.code}`, 
						msg: error.message
					});
				} else {
					Notification.show({
						type: "error", 
						title:`Error`, 
						msg: json_lang.two_steps_modal.default_error 
					});
				}
			});
	}
}

export const deleteHoliday = (id) => {
	return (dispatch, getState) => {
		const { company, json_lang, branchHolidays } = getState();
		return axios.delete(URL + company.id + `/holidays/${id}`)
			.then(() => {
				dispatch({
					type: "BRANCH_HOLIDAYS",
					branchHolidays: branchHolidays.filter((holiday) => holiday.id !== id)
				});
				Notification.show({
					type: "success", 
					title:json_lang.common.success, 
					msg:json_lang.custom_success.delete_successful 
				});
			})
			.catch((err) => {
				if(err.data){
					const error = localizedErrorHandler(err.data);
					Notification.show({
						type: "error", 
						title:`Error ${error.code}`, 
						msg: error.message
					});
				} else {
					Notification.show({
						type: "error", 
						title:`Error`, 
						msg: json_lang.two_steps_modal.default_error 
					});
				}
			});
	}
}

export {
	toggleDataBranchServiceModifiers,
	addBranchServiceModifiers,
	deleteBranchServiceModifiers,
	toggleDataPricelist,
	storePriceList,
	getPriceList,
	getPriceListId,
	editPriceList,
	deletePriceList,
	getBranchCurrencies,
	createBranchCurrency,
	clearBranchCurrency,
	toogleBranchCurrency,
	deleteBranchDeliveryFeeSteps,
	updatebranchDeliveryFeeSteps,
	addBranchDeliveryFeeSteps,
	clearNewBranch,
	ClearBranchGroup,
	clearBranchGroupSettings,
	getBrancchGroupAcceses,
	fetchBranchSettings,
	updateBranchSetings,
	updateAutoAssignDriverUponPayment,
	updateBranchSetingsWorkSchedules,
	DeleteAccesessss,
	Addaccesessss,
	accesessss,
	AddBranchGroup,
	fetchBranchGroup,
	toggleBranchEnabledStatus,
	toggleBranchVisibleStatus,
	updateSelectedBranch,
	fetchCompanyBranches,
	fetchProviderBranchAccesses,
	toggleData,
	toggleData2,
	updateBranchInServiceStatus,
	updateBranchSettings,
	updateBranchPayment,
	fetchBranch,
	fetchBranchGroups,
	fetchBranchGroupsByIds,
	clearBranchGroupsByIds,
	AddBranchInGroup,
	DeleteBranch,
	toggleData3,
	DeleteBranchGroup,
	clearBranch,
	toggleBranchServiceStatus,
	toggleBranchInFeature,
	updateBranchInfo,
	updateBranchCommercies,
	EditBranchGroup,
	EditBranchGroupSettings,
	updateBranchAddress,
	toggleData4,
	getBranchRatings,
	getOrderBranchRatings,
	getBranchDeliveryFees,
	toggleDataBranchFeeds,
	excelConfigUpdate,
	pushExcelImport,
	deleteExcelImport,
	fetchBranchlist,
	fetchBranchlistForMap,
	bulkbranchesActions,
	clearPriceList,
	clearAdmindAccessList,
	searchBranchesByCity,
	updateBranchPaymentEmails
}



// WEBPACK FOOTER //
// ./src/store/actions/branches/branchActions.js